// Module
var code = "<h2 id=\"have-questions\">Have Questions?</h2> <p>Visit the Co-signer FAQ.</p> ";
// Exports
export default code;